import { useState } from "react";

function FileProductsConnector({
  index,
  data = [],
  productsList,
  fileType,
  onDataChange,
  readOnly = "false",
}) {
  const [products] = useState(
    productsList.sort((a, b) => a.productName.localeCompare(b.productName))
  );
  const [productQuantities] = useState(
    productsList.map((product) => {
      return {
        productName: product.productName,
        quantity: product.quantity,
        unit: product.unit,
      };
    })
  );

  const arraysEqual = (a, b) => {
    if (a.length !== b.length) return false;
    return a.every(
      (item, index) => item?.productName === b[index]?.productName
    );
  };

  const [connectedProducts, setConnectedProducts] = useState(() => {
    if (!Array.isArray(data)) {
      return [];
    }
    return data
      .filter((item) => item && item.productName)
      .sort((a, b) => a.productName.localeCompare(b.productName));
  });

  const [filter, setFilter] = useState("");
  const [showSelector, setShowSelector] = useState(false);

  const findProductQuantityAndUnit = (productName) => {
    const product = productQuantities.find(
      (product) => product.productName === productName
    );
    return product ? `${product.quantity} ${product.unit}` : "";
  };

  const selectAll = () => {
    setFilter("");
    const validProducts = products.filter((p) => p && p.productName);
    setConnectedProducts(validProducts);
    onDataChange(validProducts, fileType, index);
  };

  const clearAll = () => {
    setFilter("");
    setConnectedProducts([]);
    onDataChange([], fileType, index);
  };

  const updateConnections = (newConnections) => {
    const sanitizedConnections = newConnections.filter(
      (item) => item && item.productName
    );
    setConnectedProducts(sanitizedConnections);
    onDataChange(sanitizedConnections, fileType, index);
  };

  if (showSelector === false) {
    return (
      <div className="w-100">
        {connectedProducts.length > 0 ? (
          <div className="d-flex flex-column">
            <span className="mb-1">Powiązane towary:</span>
            <ul>
              {connectedProducts.map((product, idx) => (
                <li key={`connectedProduct_${idx}`}>
                  {product.productName} -{" "}
                  {findProductQuantityAndUnit(product.productName)}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className="">Brak powiązanych towarów.</div>
        )}

        {[false, "false"].includes(readOnly) && (
          <button
            type="button"
            className="btn btn-outline-primary w21 mt-1"
            onClick={() => setShowSelector(true)}
          >
            Wybierz towary, których dotyczy ten dokument
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="w-100">
      <div className="d-flex flex-row">
        <input
          type="text"
          className="form-control rounded-end-0 h2 w23"
          placeholder="Filtruj towary"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
        <button
          type="button"
          className="btn btn-outline-secondary border border-start-0 rounded-start-0 h2 tooltip text-dark"
          onClick={() => setFilter("")}
        >
          X<span className="tooltiptext">Wyczyść filtr</span>
        </button>
        <button
          type="button"
          className="btn btn-outline-primary w9 h2 ms-auto"
          onClick={() => selectAll()}
        >
          Zaznacz wszystkie
        </button>
        <button
          type="button"
          className="btn btn-outline-primary w11 h2 ms-1"
          onClick={() => clearAll()}
        >
          Wyczyść zaznaczenie
        </button>
      </div>

      {products.length > 0 && [false, "false"].includes(readOnly) ? (
        products
          .filter(
            (product) =>
              product &&
              product.productName &&
              product.productName.toLowerCase().includes(filter.toLowerCase())
          )
          .map((product, indx) => (
            <div key={`product_${indx}`} className="d-flex flex-row mt-1">
              <input
                type="checkbox"
                className="form-check-input"
                id={`product_${indx}`}
                value={product.productName}
                onChange={(e) => {
                  if (e.target.checked) {
                    const newProduct = { productName: product.productName };
                    const newConnections = [...connectedProducts, newProduct];
                    updateConnections(newConnections);
                  } else {
                    const newConnections = connectedProducts.filter(
                      (prod) => prod.productName !== product.productName
                    );
                    updateConnections(newConnections);
                  }
                }}
                checked={connectedProducts.some(
                  (prod) => prod && prod.productName === product.productName
                )}
              />
              <label className="form-check-label" htmlFor={`product_${indx}`}>
                {product.productName}
              </label>
            </div>
          ))
      ) : (
        <div className="d-flex flex-row mb-1">
          Towary, których dotyczy ten dokument
        </div>
      )}

      <button
        type="button"
        className="btn btn-outline-primary rounded-2 w7 h2 mt-1"
        onClick={() => setShowSelector(false)}
      >
        Zatwierdź
      </button>
    </div>
  );
}

export default FileProductsConnector;
